exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:PingFangSC-Regular;src:url(\"/static/css/PingFangRegular.ttf\") format(\"embedded-opentype\"),url(\"/static/css/PingFangRegular.ttf\") format(\"woff\"),url(\"/static/css/PingFangRegular.ttf\") format(\"truetype\"),url(\"/static/css/PingFangRegular.ttf\") format(\"svg\")}.title[data-v-5e153f27]{font-family:PingFangSC-Regular;font-size:16px;color:#000;letter-spacing:0;height:25px;line-height:25px}.content[data-v-5e153f27]{font-family:PingFangSC-Regular;font-size:14px;color:#767a81;letter-spacing:.2px;line-height:21px;margin-top:8px;margin-bottom:8px}ul[data-v-5e153f27]{list-style-type:none;text-align:left;padding:0;margin:0}li[data-v-5e153f27]{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e153f27","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Index/Course/Introduce.vue
// module id = OFae
// module chunks = 1